module.exports = __webpack_public_path__ + "34bc775d/img/search-filter-icon.c4751a52.svg";